
import { css } from 'lit';
export default css`
/* Apply CSS Variables to the host element. */
:host{
  --sic-chip-icon-size:var(--spacing-04);
  --sic-chip--default--family:var(--ff-body);
  --sic-chip--default--weight:var(--fw-bold);
  --sic-chip--default--margin:0;
  --sic-chip--default--margin--lg:var(--spacing-01) 0;
  --sic-chip--default--padding:var(--spacing-02) var(--spacing-03);
  --sic-chip--default--padding--lg:var(--spacing-01) var(--spacing-03);
  --sic-chip--default--radius:var(--border-radius-button-default);

  --sic-chip--default--bg-color:var(--color-neutral-white);
  --sic-chip--default--text-color:var(--color-primary-default);
  --sic-chip--default--border-color:var(--color-primary-default);
  --sic-chip--default--border-width:var(--border-width-thicker );
  --sic-chip--default--bg-color--hover:var(--color-primary-lightest);
  --sic-chip--default--text-color--hover:var(--color-primary-default);
  --sic-chip--default--margin--lg--hover:0;
  --sic-chip--default--padding--lg--hover:var(--spacing-02) var(--spacing-03);
  --sic-chip--default--bg-color--focus:var(--color-neutral-white);
  --sic-chip--default--text-color--focus:var(--color-primary-default);
  --sic-chip--default--outline-color--focus:var(--color-primary-default);
  --sic-chip--default--outline-width--focus:var(--border-width-thicker);
  --sic-chip--default--outline-offset--focus:var(--border-width-thicker);
}
`;